var menuIsCollapsed;

function closeMenu() {
    if(!$('header').hasClass("collapsed")) {
        $('header').addClass("collapsed");
        $('.masthead__menuOverlay').fadeOut();
    }
}

function openMenu() {
    if($('header').hasClass("collapsed")) {
        $('header').removeClass("collapsed");
        $('.masthead__menuOverlay').fadeIn();
    }
}

function refreshMenuHome() {
    // MENU
    if($(window).scrollTop()==0){
        $('header').addClass("scrollTopPosition");
    } else {   
        $('header').removeClass("scrollTopPosition");
    }
    // SOLVING PARALLAX IN HOME
    if($(window).scrollTop()>$(window).height()){
        jQuery('.topBannerAnimation').css("opacity","0");
    } else {
        jQuery('.topBannerAnimation').css("opacity","1");
    }
}

function initScroll() {
    if($('.home').length != 0){
        refreshMenuHome();
    } else {
        $('header').removeClass("scrollTopPosition");
    }
}

function initMenu() {
    // INIT
    closeMenu();
    // ADD MENU TOGGLE BT TRIGGER
    $('.menuToggleBt').click(function(event){
        console.log("CLICK ON MENU TOGGLE");
		event.preventDefault();
        if($('header').hasClass("collapsed")) {
            openMenu();
        } else {
            closeMenu();
        }
    });
    // ADD MENU CLOSE BT TRIGGER
    $('.menuCloseBt').click(function(event){
        console.log("CLICK ON MENU TOGGLE");
		event.preventDefault();
        if($('header').hasClass("collapsed")) {
            openMenu();
        } else {
            closeMenu();
        }
    });
    // CLICK OUTSIDE
    $('.masthead__menuOverlay').click(function(event){
        event.preventDefault();
        console.log("CLICK");
        if(!$('header').hasClass("collapsed")) {
            $('header').addClass("collapsed");
            $('.masthead__menuOverlay').fadeOut();
        }
    });
    // ADD SCROLL TRIGGER (HOME PARTICULAR CASE)
    // Init
    initScroll();
    // Scroll binding
    $(window).scroll(function() {
        if($('.home').length != 0){
            refreshMenuHome();
        }
    });
    // ARROW
    $(".arrowHome").click(function(event){
        var mastheadH = $('.masthead__content').height();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#mainExhibition").offset().top-mastheadH
        }, 800);
    });
}

// ON PAGE READY
(function(w, d){
    //console.log("INIT MENU");
	initMenu();
}(window, document));